export const FenceTypeSelector = function ({
  currentType,
  onSelect,
  onRemove,
  onClose
}: {
  currentType: FenceVehicleType;
  onSelect: (type: FenceVehicleType) => void;
  onRemove: () => void;
  onClose: () => void;
}) {
  return (
    <div
      className="w-48 rounded-lg bg-white p-3 text-xs shadow-lg"
      style={{
        position: "absolute",
        transform: "translate(-50%, calc(-100% - 14px))",
        pointerEvents: "auto"
      }}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-1.5 top-1.5 text-base leading-none text-gray-400 hover:text-gray-600"
      >
        ×
      </button>
      <p className="mb-2 pr-4 font-semibold text-gray-900">
        Vehicle Type Allowed
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onSelect("small")}
          className={[
            "flex-1 rounded-md border px-2 py-1.5 text-xs",
            currentType === "small"
              ? "border-orange-500 bg-orange-500 text-white"
              : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
          ].join(" ")}
        >
          Small
        </button>
        <button
          type="button"
          onClick={() => onSelect("medium")}
          className={[
            "flex-1 rounded-md border px-2 py-1.5 text-xs",
            currentType === "medium"
              ? "border-blue-500 bg-blue-500 text-white"
              : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
          ].join(" ")}
        >
          Medium
        </button>
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="mt-2 w-full text-center text-[11px] text-red-600 underline"
      >
        Remove This Fence
      </button>
    </div>
  );
};
